import { useQuery } from '@tanstack/react-query';
import { endpoints, Url } from '@rossum/api-client';
import { useApiClient } from '../../../lib/apiClient';

const CONFIGURATION_MAP_QUERY_KEY = 'configuration-map';

export const useConfigurationMap = (queueUrl: Url) => {
  const api = useApiClient();

  return useQuery({
    queryKey: [CONFIGURATION_MAP_QUERY_KEY, queueUrl] as const,
    queryFn: () =>
      api.request(endpoints.internal.configurationMap({ queue: queueUrl })),
    select: data => data.results,
  });
};
